import { render } from "./ProductCard.vue?vue&type=template&id=70e5eabc&ts=true"
import script from "./ProductCard.vue?vue&type=script&lang=ts"
export * from "./ProductCard.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/mikesteer/Documents/web/ecom/HasBean/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__